import { createUseQuery } from 'api/common/createUseQuery'
import { fetchWinners } from 'api/fetchers/fetchWinners'
import { AwardsFile } from 'types/AwardsFile'

export const useFetchWinners = () => {
  const useQuery = createUseQuery({
    queryKey: ['WINNERS'],
    fetcher: () => fetchWinners(),
    selector: res => res?.data ?? ({} as AwardsFile[]),
  })

  const query = useQuery()

  return {
    data: query.data as AwardsFile[],
    error: query.error,
    isLoading: query.isLoading,
  }
}
